export default __webpack_public_path__ + "static/media/fax.0dcbced1.svg";